module.exports = __webpack_public_path__ + "img/product_accessory.fa37b7a.png";